document.addEventListener("DOMContentLoaded", () => {


  









  const submenuToggles = document.querySelectorAll(".wp-block-navigation-submenu__toggle");

  submenuToggles.forEach(toggle => {
    toggle.addEventListener("click", function() {
      const li = this.parentElement;
      
      if (
        li.classList.contains("ddl-active") ||
        li.querySelector(".ddl-active") ||
        li.querySelector(".wp-block-navigation-submenu").style.display === "block"
      ) {
        li.classList.remove("ddl-active");
        li.querySelectorAll(".ddl-active").forEach(active => active.classList.remove("ddl-active"));
        li.querySelector(".wp-block-navigation-submenu").style.display = "none";
      } else {
        li.classList.add("ddl-active");
        li.querySelector(".wp-block-navigation-submenu").style.display = "block";
      }
    });
  });
});
